<template>
  <div class="forget-wrapper">
    <div class="forget">
      <h1 style="color: #000"><b>Reset Your LuxTag Password</b></h1>
      <p v-if="isEmailSent" style="font-size: 1.6em;">A message has been sent to {{ruleForm.email}} with instructions on how to reset your password.</p>
      <p v-if="!isEmailSent" style="font-size: 1.6em;">Submit your email address and we’ll send you a link to reset your password.</p>
      <el-form v-if="!isEmailSent" :model="ruleForm" :rules="rulesPass" ref="ruleForm" label-width="120px" label-position="top">
        <el-form-item label="Email" prop="email">
          <el-input id="email" type="text" @keyup.enter="submitForm('ruleForm')" v-model="ruleForm.email" auto-complete="off" />
        </el-form-item>
        <el-form-item style="margin-top: 40px;">
          <el-button type="primary" class="el-button-login" @click="submitForm('ruleForm')" :loading="isSubmitButtonLoading">Submit</el-button>
        </el-form-item>
     </el-form>
    </div>
   </div>
</template>

<script>
import luxtagApi from '../API/index';

export default {
  data() {
    const checkEmail = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input your Email'));
      } else {
        // eslint-disable-next-line
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(value)) {
          callback(new Error('Please input correct email address'));
        }
      }
      callback();
    };
    return {
      isSubmitButtonLoading: false,
      isEmailSent: false,
      ruleForm: {
        email: '',
      },
      rulesPass: {
        email: [
          { required: true, validator: checkEmail, trigger: 'blur' },
        ],
      },
    };
  },
  computed: {
  },
  methods: {
    submitForm(formName) {
      this.isSubmitButtonLoading = true;
      const that = this;
      // Create a common object
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // POST forgot password request
          luxtagApi.user.forgotPw(that.ruleForm.email)
          .then((response) => {
            // success
            this.isEmailSent = true;
          }).catch((error) => {
            // error callback
            this.isSignUpButtonDisable = false;
            let errorMessage = '';
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              if (error.response.status === 404) {
                errorMessage = 'There wasn\'t an account for that email';
              } else if (error.response.data.length > 0) {
                errorMessage = error.response.data;
              } else {
                errorMessage = 'There was an error';
              }
            } else if (error.request) {
              errorMessage = 'Please check your connection'; // status 0
            } else {
              // Something happened in setting up the request that triggered an Error
              errorMessage = error.message;
            }

            that.$message.error({
              showClose: true,
              message: errorMessage,
            });
          });
        } else {
          that.$message.error({
            showClose: true,
            message: 'Invalid Form!',
          });
          // stop button loading
          this.isSubmitButtonLoading = false;
        }
      });
    },
  },
};
</script>

<style>
.forget-wrapper {
  max-width: 540px;
  margin: 0 auto;
  padding: 2em 1em;
  width: 100%;
}

  p {
    color: #000;
  }

.forget {
  display: block;
  text-align: left;
}
.el-button {
  color: #1960AF;
}
.el-button:hover {
  color: #41A3F7;
}
.el-button-login {
  color: #fff;
  background-color: #1960AF;
  border-color: #1960AF;
}
.el-button-login:hover {
  color: #fff;
  background-color: #41A3F7;
  border-color: #41A3F7;
}

@media only screen and (min-width: 900px) {
  .forget-wrapper {
      max-width: 1300px;
      margin: 0 auto;
      padding: 3em 1em;
  }
  .forget {
    display: block;
    max-width: 585px;
    margin: 0 auto;
    position: relative;
  }
}

.el-form--label-top .el-form-item__label {
    padding: 0px;
}

.el-form-item {
    margin-bottom: 1.13em;
}
</style>

<style scoped>
  form {
    max-width: 400px;
  }
  .el-form-item.is-required .el-form-item__label:before {
    display: none;
  }
  .el-button--primary {
    color: #fff !important;
  }
</style>



// WEBPACK FOOTER //
// Forgot.vue?9534aef8